var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3140_90668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4168 7.00016C13.4168 10.544 10.544 13.4168 7.00016 13.4168C3.45633 13.4168 0.583496 10.544 0.583496 7.00016C0.583496 3.45633 3.45633 0.583496 7.00016 0.583496C10.544 0.583496 13.4168 3.45633 13.4168 7.00016ZM6.25795 10.3977L11.0187 5.63698C11.1804 5.47533 11.1804 5.2132 11.0187 5.05154L10.4333 4.4661C10.2716 4.30441 10.0095 4.30441 9.84779 4.4661L5.96522 8.34865L4.15253 6.53596C3.99088 6.37431 3.72875 6.37431 3.56707 6.53596L2.98162 7.12141C2.81996 7.28307 2.81996 7.54519 2.98162 7.70685L5.67248 10.3977C5.83417 10.5594 6.09627 10.5594 6.25795 10.3977Z",
    fill: "#595959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3140_90668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.0dedab549d4f64a8970f566a01ce16b3.svg";
export { ForwardRef as ReactComponent };